<script setup lang="ts">
import { computed, watch } from "vue";
import { container } from "tsyringe";

// shared
import { useQueryErrorCapture } from "@/shared/composables/useQueryErrorCapture";

// features
import { DetailPendingRegistrationService } from "@/features/pending-registration/services/service/DetailPendingRegistrationService";
import { useQueryDetailRegistrationUser } from "@/features/pending-registration/services/query/useQueryDetailRegistrationUser";
import type { DetailPendingRegistrationPopupRestProps } from "@/features/pending-registration/models/interface";
import CommonForm from "@/features/pending-registration/ui/detail-popup/CommonForm.vue";
import StudentDetailForm from "@/features/pending-registration/ui/detail-popup/StudentDetailForm.vue";

const detailPendingRegistrationService = container.resolve(DetailPendingRegistrationService);
const { capture } = useQueryErrorCapture();

const props = defineProps<DetailPendingRegistrationPopupRestProps>();

const { userDto, isPending, error } = useQueryDetailRegistrationUser({
    userId: props.userId,
    userType: props.userType,
});

const convertedUserInformation = computed(() => {
    if (!userDto.value) {
        return null;
    }

    return detailPendingRegistrationService.convertFormDataByUserType(userDto.value);
});

// 에러 발생시 capture 하여 alert 를 띄어줍니다.
watch(error, () => {
    if (error.value) {
        capture(error.value);
    }
});
</script>

<template>
    <div class="size-full">
        <div v-if="isPending">
            <div class="flex justify-center items-center size-full">
                <div class="bg-gray-200 rounded-full animate-spin size-10"></div>
            </div>
        </div>
        <div v-else-if="error">
            <div class="flex justify-center items-center size-full">에러가 발생하였습니다.</div>
        </div>
        <div v-else class="flex justify-center items-center size-full">
            <component
                v-if="convertedUserInformation"
                :is="convertedUserInformation.type === '학생' ? StudentDetailForm : CommonForm"
                :registration-id="props.registrationId"
                :converted-form-data="convertedUserInformation"
                :is-pending="isPending"
            />
        </div>
    </div>
</template>

<style lang="scss" scoped></style>
